import moment from "moment";
import React, { useState, useRef } from "react";
import { FormattedMessage } from "react-intl";
import ReactDOM from "react-dom";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import { Dialog, Grid, IconButton, TextField } from "@material-ui/core";
import { StaticDatePicker } from "@material-ui/pickers";

import { theme } from "./datePickerTheme";
import Time from "./time";
import CalendarIcon from "../icons/calendarIcon";
import Button from "../button/button";

const useStyles = makeStyles({
    button: {
        margin: "0px 25px 25px 25px",
        padding: "10px 15px",
        float: "right",
    },
});

export const CMISDateTimePicker = (props) => {
    const { label, value, onChange, error, variant, fontSize, inputSize, role, iconSize, dateType, minDate } = props;

    const classes = useStyles();
    const [dateTime, setDateTime] = useState(value);
    const [isOpen, setIsOpen] = useState(false);

    const onSave = () => {
        onChange(dateTime);
        handleClose();
    };

    // use a reference to the popper to add our
    // time control
    const popperRef = useRef(null);
    const setPopperRef = (ref) => {
        popperRef.current = ref;

        if (popperRef.current !== null) {
            const selectedButtonDiv = popperRef.current.popper.querySelector(".bell-time-capture");

            // don't add it if it already exists
            if (selectedButtonDiv) {
                return;
            }

            // Create the container div for the time component
            const pickerRoot = popperRef.current.popper.children[1];
            const timeDiv = document.createElement("div");

            timeDiv.className = "bell-time-capture";
            pickerRoot.appendChild(timeDiv);

            // Render the time component to the time capture div
            ReactDOM.render(
                <React.StrictMode>
                    <Time
                        label={
                            <FormattedMessage
                                id="select-date-time.title"
                                defaultMessage="Select start time"
                                description="Select start time for request"
                            />
                        }
                        time={dateTime}
                        onChange={setDateTime}
                    />
                </React.StrictMode>,
                timeDiv,
            );
        }
    };

    const handleOpen = () => {
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const val = value ? moment(value).format("DD/MM/YYYY HH:mm") : "";
    let inputProps = {
        helperText: "dd/mm/yyyy hh:mm",
        label: label,
        variant: variant,
        size: inputSize,
        InputProps: {
            value: val,
            onClick: handleOpen,
            endAdornment: (
                <IconButton size={iconSize ? iconSize : "medium"} onClick={handleOpen}>
                    <CalendarIcon />
                </IconButton>
            ),
        },
    };
    // if(fontSize){
    //     inputProps = {
    //         ...inputProps,
    //         endAdornment: <IconButton size={fontSize} onClick={handleOpen}><CalendarIcon /></IconButton>,
    //         size : {fontSize}
    //     }
    // }
    return (
        <React.Fragment>
            <ThemeProvider theme={theme}>
                <TextField {...inputProps} error={!!error} helperText={error} fullWidth role={props.role} />{" "}
                <Dialog
                    open={isOpen}
                    onClose={handleClose}
                    // className={dialogClasses.dialog}
                >
                    <StaticDatePicker
                        style={props.style}
                        label={label}
                        value={dateTime}
                        onChange={setDateTime}
                        format="MMM d, yyyy hh:mm"
                        showDaysOutsideCurrentMonth={true}
                        disableCloseOnSelect={true}
                        showToolbar={false}
                        disableFuture={dateType ? (dateType == "expirationDate" ? false : true) : false}
                        disablePast={minDate ? (minDate == "today" ? true : false) : false}
                    />
                    <Time
                        label={
                            <FormattedMessage
                                id="select-date-time.title"
                                defaultMessage="Select start time"
                                description="Select start time for request"
                            />
                        }
                        time={dateTime}
                        onChange={setDateTime}
                    />
                    <Grid container>
                        <Grid item md={12}>
                            <Button onClick={onSave} primary className={classes.button}>
                                <FormattedMessage
                                    id="select-date-domain.accept-caption"
                                    defaultMessage="Apply"
                                    description="Apply selected date range"
                                />
                            </Button>
                            <Button onClick={handleClose} tertiary className={classes.button}>
                                <FormattedMessage
                                    id="select-date-domain.cancel-caption"
                                    defaultMessage="Cancel"
                                    description="Cancel selected date range"
                                />
                            </Button>
                        </Grid>
                    </Grid>
                </Dialog>
            </ThemeProvider>
        </React.Fragment>
    );
};

export default CMISDateTimePicker;
